// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__SdIHu","rows":"style_rows__2GeYF","row":"style_row__1-Zta","subtitle":"style_subtitle__3Jz8K","grid":"style_grid__28PlB"};